require('./aggregatorSummary.scss');

// import { List } from 'immutable'
import React from 'react';
import PropTypes from 'prop-types';

const Immutable = require('immutable');
const { EURO_TEXT } = require('constants/index');
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

import { KO, PENDING } from 'constants/aggregator/statuses';
import { AUTHENTICATING, AUTHENTICATION_ERROR } from 'constants/aggregator/tinkStatuses.constants';

const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class AggregatorSummary extends React.PureComponent {
  calculateFinalEURAmount = (immAmounts, keepSign, sumAbs) => {
    // @hardcoded
    let amount = 0;

    if (immAmounts) {
      amount = immAmounts
        .filter(am => am && am.get)
        .map(amountObject => {
          return amountObject.get('amount');
        })
        .reduce((prev, next) => {
          if (!sumAbs) return prev + next;

          return Math.abs(prev) + Math.abs(next);
        });
    }

    return Immutable.fromJS({
      amount: keepSign ? amount : Math.abs(amount),
      currency: EURO_TEXT,
    });
  };

  buildSavings = (keepSign, sumAbs = false) => {
    const {
      immAccounts,
      immGlobalPosition,
      immWalletSummarization,
      immWealthRoboValues,
      immCards,
      immAggregatorData,
      isBalanceDrawn,
    } = this.props;
    const immAggregatorSavingAndInvestment = [
      immAggregatorData.getIn(['data', 'savingAndInvestment']),
    ];

    const immSavings = immGlobalPosition.get('savings');

    const accountBalance = isBalanceDrawn
      ? immAccounts.get('balanceDrawnForGlobalPosition')
      : immAccounts.get('balanceForGlobalPosition')

    const savingsAmounts = accountBalance
      .concat(
        immCards.get('ecard').get('availableBalanceForPG'),
        immSavings.get('totalAvailableBalance'),
        immWalletSummarization.getIn(['values', 'balance']),
        immWalletSummarization.getIn(['futures', 'balance']),
        immWalletSummarization.getIn(['plans', 'balance']),
        immWalletSummarization.getIn(['funds', 'balance']),
        immWealthRoboValues.get('balance'),
        immAggregatorSavingAndInvestment
      );

    return getPlainAmountObject(this.calculateFinalEURAmount(savingsAmounts, keepSign, sumAbs));
  };

  buildFinancing = (keepSign, sumAbs = false) => {
    const { immCards, immLoans, immAggregatorData } = this.props;
    const immAggregatorFinancing = [immAggregatorData.getIn(['data', 'financing'])];

    const loansBalance = immLoans.get('loansBalanceForPG');
    const mortgagesBalance = immLoans.get('mortgagesBalanceForPG');
    const cardsBalance = immCards.getIn(['credit', 'balanceDrawnForPG']);
    const financingsAmounts = loansBalance.concat(
      mortgagesBalance,
      cardsBalance,
      immAggregatorFinancing
    );

    return getPlainAmountObject(this.calculateFinalEURAmount(financingsAmounts, keepSign, sumAbs));
  };

  renderData = (translationKey, plainAmountObject) => {
    return (
      <div className="row aggregator-summary__item">
        <div className="col-xs-6 aggregator-summary__item__left-column">
          <FormattedText
            value={`aggregatorSummary-${translationKey}`}
            className="aggregator-summary__item__label"
          />
        </div>
        <div className="col-xs-6 aggregator-summary__item__right-column">
          <OneLineSymbolAmount
            amountObject={plainAmountObject}
            className="aggregator-summary__item__amount"
            language={getLanguage()}
            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
          />
        </div>
      </div>
    );
  };

  render() {
    const financing = this.buildFinancing(false, true);
    const savings = this.buildSavings(true, true);
    const { immAggregatorData } = this.props;
    const banks = immAggregatorData.getIn(['data', 'banks']);
    const ERROR_OR_PENDING_STATUSES = [
      // Eurobits
      PENDING,
      KO,
      // Tink
      AUTHENTICATING,
      AUTHENTICATION_ERROR,
    ];

    if (
      !banks.size ||
      banks.every(
        b =>
          ERROR_OR_PENDING_STATUSES.includes(b.get('status')) ||
          ERROR_OR_PENDING_STATUSES.includes(b.get('tinkStatus'))
      ) ||
      immAggregatorData.get('error')
    )
      return null;

    return (
      <div className="aggregator-summary">
        <div className="aggregator-summary__header">
          <FormattedText value="aggregatorSummary-titleKey" />
        </div>
        <div className="aggregator-summary__content">
          {this.renderData('savingsText', savings)}
          {this.renderData('financingText', financing)}
        </div>
      </div>
    );
  }
}

AggregatorSummary.propTypes = {
  immAggregatorData: PropTypes.object.isRequired,
  immCards: PropTypes.object.isRequired,
  immAccounts: PropTypes.object.isRequired,
  immGlobalPosition: PropTypes.object.isRequired,
  immWealthRoboValues: PropTypes.object.isRequired,
  landingBoxes: PropTypes.object.isRequired,
  immWalletSummarization: PropTypes.object.isRequired,
  hasInvestments: PropTypes.number.isRequired,
  immLoans: PropTypes.object.isRequired,
  isBalanceDrawn:  PropTypes.bool,
};

export { AggregatorSummary };
